var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 5.80441L7.51126 11.4667C7.34648 11.6256 7.12678 11.7147 6.89792 11.7156C6.66719 11.7194 6.44403 11.6333 6.27565 11.4755L2.72022 8.05337C2.4289 7.70672 2.44479 7.19673 2.75663 6.86882C3.06866 6.54091 3.57739 6.49968 3.93797 6.77332L6.88917 9.59118L12.0535 4.53328C12.4046 4.17984 12.9756 4.17788 13.3291 4.52882C13.6825 4.87993 13.6846 5.45097 13.3335 5.80441ZM14.2225 0H1.7779C0.796126 0 0 0.795948 0 1.7779V14.2225C0 14.6939 0.18725 15.146 0.520695 15.4795C0.85414 15.8129 1.30629 16.0002 1.77772 16.0002H14.2223C14.6937 16.0002 15.1459 15.8129 15.4793 15.4795C15.8128 15.146 16 14.6939 16 14.2225V1.77772C16 1.30629 15.8128 0.853962 15.4793 0.520695C15.1459 0.187429 14.6941 0 14.2225 0Z",
    fill: "#2469EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.bd9d9f555c6d1db5c520844bfb3089e6.svg";
export { ForwardRef as ReactComponent };